import React from "react";
import {
  update_botTyping_to_true,
  update_botTyping_to_false,
} from "../../../../store/actions/botTypingAction";
import { connect } from "react-redux";
import {
  close_modal,
  open_modal,
} from "../../../../store/actions/modalStatusAction";
import "./Message.css";
// import axios from "axios/index";
// import { chatbot_api_host } from "../../../../config";
import Parser from "html-react-parser";
// import { sendPrivateMessage } from "../../../../services/socketServices";
// import uuid from "react-uuid";
// import HermesRating from "../bot_utility_components/HermesRating";
import JumpingDots from "../../../misc/JumpingDots";
import MessageActions from "../../messages/MessageActions";
import AdsCarousal from "../../AdsCarousal";
import SingleAccount from "../../indianbank/workflow_components/account_balance/SingleAccount";
import MultipleAccounts from "../../indianbank/workflow_components/workflow_utility_components/account_list/MultipleAccounts";
import MultipleAccountsModal from "../../indianbank/workflow_components/workflow_utility_components/account_list/MultipleAccountsModal";
import CifDateofBirthForm from "../../workflowComponents/CifDateofBirthForm";
import AccountList from "../../indianbank/workflow_components/workflow_utility_components/account_list/AccountList";
import AgrAccountList from "../../indianbank/workflow_components/workflow_utility_components/account_list/AgrAccountList";

import NlpQaCard from "../../indianbank/nlp/NlpQaCard";
import AdyaLikeDislikeButton from "../../indianbank/adya_utility_components/AdyaLikeDislikeButton";
import TransactionModal from "../../indianbank/workflow_components/mini_statement/TransactionModal";
import TransactionList from "../../indianbank/workflow_components/mini_statement/TransactionList";
import TransactionTable from "../../indianbank/workflow_components/mini_statement/TransactionTable";
import MiniStatementCard from "../../indianbank/workflow_components/mini_statement/MiniStatementCard";
import MiniStatementList from "../../indianbank/workflow_components/mini_statement/MiniStatementList";
import GuidedMenuCard from "../../indianbank/cards/GuidedMenuCard";
import HeroCardMenu from "../../indianbank/cards/HeroCard";
import QuickMenuCard from "../../indianbank/cards/QuickMenuCard";
import DateOfBirthSelect from "../../indianbank/workflow_components/workflow_utility_components/date_of_birth/DateOfBirthSelect";
import DateofBirthCard from "../../indianbank/workflow_components/workflow_utility_components/date_of_birth/DateOfBirthCard";
import AdyaTimeStamp from "../../indianbank/adya_utility_components/AdyaTimeStamp";
import FaqMenuCard from "../../indianbank/cards/FaqMenuCard";
import FaqMenuCardTest from "../../indianbank/cards/FaqMenuCardTest";
import MiniStatementListTest from "../../indianbank/workflow_components/mini_statement/MiniStatementListTest";
import MiniStatementUAT from "../../indianbank/workflow_components/mini_statement/MiniStatementUAT";
import MiniStatementUATDemo from "../../indianbank/workflow_components/mini_statement/MiniStatementUATDemo";
import ChequeBookFormRequest from "../../indianbank/workflow_components/cheque_book_request/ChequeBookFormRequest";
import ChequeBookRequest from "../../indianbank/workflow_components/cheque_book_request/ChequeBookRequest";
import ChequeBookFormRequestErrRes from "../../indianbank/workflow_components/cheque_book_request/ChequeBookFormErrRes";
// import NlpCardTest from "../../indianbank/nlp/dws_nlp/NlpCardTest";
import NlpCardHerocard from "../../indianbank/nlp/dws_nlp/NlpCardHerocard";
import AgrLinkData from "../../indianbank/cards/AgrLinkData";
import DatePicker from "../../indianbank/workflow_components/workflow_utility_components/date_of_birth/DatePicker";
import DateRange from "../../indianbank/workflow_components/workflow_utility_components/date_of_birth/DateRange";
import DateRangeste from "../../indianbank/workflow_components/workflow_utility_components/date_of_birth/DateRangeste";
import WelcomeMessage from "../../indianbank/cards/WelcomeMessage";
import UserSelectorModal from "../../../modals/UserSelectorModal";
import OtpValidation from "../../indianbank/workflow_components/workflow_utility_components/otp/OtpValidation";
import { MobileNumber } from "../../indianbank/workflow_components/workflow_utility_components/mobile_number/MobileNumber";
import ViewAccountDetails from "../../indianbank/workflow_components/workflow_utility_components/ViewAccountDetails";
import TermDepositEnquiry from "../../indianbank/workflow_components/workflow_utility_components/TermDepositEnquiry";
import StopChequePaymentForm from "../../indianbank/workflow_components/workflow_utility_components/StopChequePaymentForm";
// import eventBus from"./eventBus"/home/mounikareddy/Desktop/adyagit/IB_BOT_UI/src/components/chatbot/EventBus.js
import EventBus from '../../EventBus';
class Message extends React.Component {
  constructor(props) {
    debugger
    super(props);
    
    console.log("..", props);
    this.feedbabkInputRef = React.createRef();
    this.state = {
      readMoreClicked: false,
      isShowMoreClicked: false,
    };
    
  }
  // funcion

  toggleisShowMoreClicked(value) {
    this.setState({ isShowMoreClicked: value });
  }
  onSendWorkFlowSCPData(data){
    console.log("jhhhhhhhhhhhhsdak",data)
    EventBus.emit("escp_form_data",data)
  }
  
 
  // onSendWorkFlowSCPData(val){
  //   console.log("Came here", val)
  // }

  // componentDidMount() {
  //   // console.log(
  //   //   "Message Component Mounted..!",
  //   //   this.props.speaks,
  //   //   this.props.typingBubble
  //   // );
  // }
  // fontsizeHandler=()=>{
  //   eventBus.emit('fontsizeChange', this.props.fontsize)
  // }
  render() {
    debugger
    return (
      <React.Fragment>
        {this.props.speaks == "bot" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel  z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.loadingDots && (
                  <div className="loading-container">
                    <div className="loading-bubble">
                      {this.props.tempImpMsg !== null &&
                      this.props.tempImpMsg !== undefined ? (
                        <>
                          <span style={{ marginRight: "1vw" }}>
                            {this.props.tempImpMsg}
                          </span>
                          <span className="loading-dot"></span>
                          <span className="loading-dot"></span>
                          <span className="loading-dot"></span>
                        </>
                      ) : (
                        <>
                          <span className="loading-dot"></span>
                          <span className="loading-dot"></span>
                          <span className="loading-dot"></span>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {this.props.text && !this.props.data && (
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper   border-b-l-one  notification_item"
                        : "col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one  "
                    }
                    style={{
                      background: this.props.agent && "rgb(201 202 210)",
                    }}
                  >
                    {this.props.reply_to != undefined &&
                      this.props.reply_to != "" && (
                        <p className="pointToSomeone">@{this.props.reply_to}</p>
                      )}
                    {/* <span className="black-text"> {Parser(this.props.text) }</span>  */}
                    <span
                      className={
                        this.props.fontsize === "medium"
                          ? "black-text-medium"
                          : this.props.fontsize === "large"
                          ? "black-text-large"
                          : this.props.fontsize === "small"
                          ? "black-text-small"
                          : "black-text"
                      }
                    >
                      {" "}
                      {this.props.text.length > 250 &&
                      !this.state.isShowMoreClicked
                        ? Parser(this.props.text.slice(0, 250))
                        : Parser(this.props.text)}
                    </span>

                    {!this.state.isShowMoreClicked &&
                      this.props.text.length > 250 && (
                        <span
                          className="black-text cursor_pointer"
                          style={{ textDecoration: "underline" }}
                          onClick={() => this.toggleisShowMoreClicked(true)}
                        >
                          {" "}
                          more
                        </span>
                      )}
                    {/* {this.state.isShowMoreClicked && (
                      <span className="black-text">
                        {" "}
                        {Parser(this.props.text)}
                      </span>
                    )} */}
                    {this.state.isShowMoreClicked && (
                      <span
                        className="black-text cursor_pointer"
                        style={{ textDecoration: "underline" }}
                        onClick={() => this.toggleisShowMoreClicked(false)}
                      >
                        {" "}
                        less
                      </span>
                    )}

                    {/* {this.props.isFeedback==true && (
                         <p className="pointToSomeone"
                          onClick={()=>{this.onFeedbackSend(`[${this.props.logInData.username}]: Thanks`, this.props.origin, this.props.logInData.username)}}
                          >reply</p>)} */}
                  </div>
                )}

                {this.props.text && this.props.data && (
                  <div className="col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one ">
                    {this.props.reply_to != undefined &&
                      this.props.reply_to != "" && (
                        <p className="pointToSomeone">@{this.props.reply_to}</p>
                      )}
                    <span
                      className={
                        this.props.fontsize === "medium"
                          ? "black-text-medium"
                          : this.props.fontsize === "large"
                          ? "black-text-large"
                          : this.props.fontsize === "small"
                          ? "black-text-small"
                          : "black-text"
                      }
                    ></span>
                    <p>
                      {"  "}
                      <a
                        // onClick={() =>this.openUrlToNewTab(this.props.url)}
                        //  onClick={()=>openUrlToNewWindow(props.url)}
                        onClick={() => this.setModalData(this.props)}
                      >
                        Click here
                      </a>
                    </p>
                  </div>
                )}

                {this.props.typingBubble && (
                  <div className="col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one">
                    <span className="black-text">
                      <JumpingDots noOfDots="3"></JumpingDots>
                    </span>
                  </div>
                )}

                {this.props.actions && (
                  // message-content-wrapper-bot
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper   border-b-l-one  notification_item"
                        : "col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one  "
                    }
                  >
                    {/* <span className="black-text">
                      "Thank You for Using Adya! Do You Want To Check Balance of
                      Another Account?" <br />
                    </span> */}

                    {this.props.workflowQuery == "Account Balance" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to check balance
                        of any other account? <br />
                      </span>
                    )}
                    {/* {this.props.workflowQuery == "Account Balance" && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )} */}
                    {this.props.workflowQuery == "Mini Statement" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to get mini
                        statement of any other account? <br />
                      </span>
                    )}
                    {this.props.workflowQuery == "Cheque Book Request" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to request cheque
                        book for any other account? <br />
                      </span>
                    )}
                    {this.props.workflowQuery == "Statement Through Email" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to get statement
                        of any other account? <br />
                      </span>
                    )}
                    {this.props.workflowQuery == "View Account Details" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to check account
                        details of any other account? <br />
                      </span>
                    )}
                    {this.props.workflowQuery == "Term Deposit Enquiry" && (
                      <span className="black-text">
                        Thank you for using ADYA! Do you want to check term
                        deposit of any other account? <br />
                      </span>
                    )}

{                       this.props.workflowQuery == "Stop Cheque Payement" && (
                      <span className="black-text">
                       Thank you for using ADYA! Do you want to 
                    stop payment for any other cheque(s).
                       <br />
                      </span>
                    )}
                    <MessageActions
                      actions={this.props.actions}
                    ></MessageActions>
                  </div>
                )}
                {/* {this.props.actionss && (
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper   border-b-l-one  notification_item"
                        : "col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one  "
                    }
                  >
                    {this.props.text ===
                      '<b>Account Balance</b> Workflow is enabled. Please enter "yes"' && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )}
                    {this.props.text ===
                      '<b>Mini Statement</b> Workflow is enabled. Please enter "yes"' && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )}
                    {this.props.text ===
                      '<b>Cheque Book Request</b> Workflow is enabled. Please enter "yes"' && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )}
                    {this.props.text ===
                      '<b>Statement Through Email</b> Workflow is enabled. Please enter "yes"' && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )}
                    {this.props.text ===
                      '<b>Account Balance</b> Workflow is enabled. Please enter "yes"' && (
                      <span className="black-text">
                        "Workflow is enabled. Please enter "exit" to terminate the workflow" <br />
                      </span>
                    )}
                     <MessageActions
                        actions={this.props.actions}
                      ></MessageActions>
                   
                  </div>
                )} */}
              </div>
              {this.props.text ==
                "The Email Statement has been sent to your registered email address" && (
                <div className="col s12 m8 offset-m2 offset-13 msg-outer">
                  <div className="card-panel  z-depth-1 custom-card-panel ">
                    <div
                      className="row valign-wrapper margin-b-zero"
                      id="email_stmnt_msg"
                    >
                      <AdyaTimeStamp className="" />
                      <AdyaLikeDislikeButton
                        message={this.props}
                        className="ste_likedislike"
                      />
                    </div>
                  </div>
                </div>
              )}
              {/* This is another row for rating */}
              {/* {!this.props.is_notification == true &&
                this.props.talk_to_what == "bot" && (
                  <div className="row margin-b-zero  reaction-button-wrapper ">
                    <div className="col s10 padding-zero "> */}
              {/* <HermesRating
                        query={this.props.previousQuery}
                        message={this.props}
                      ></HermesRating> */}

              {/* //   <div
                  //     class="icon-preview col s2 m3"
                  //     onClick={() => this.sendFeedback(this.props, "like")}
                  //   >
                  //     <i class="material-icons dp48 thumbs-up">thumb_up</i>{" "}
                  //   </div>
                  //   <div
                  //     class="icon-preview col s2 m3"
                  //     onClick={() => this.sendFeedback(this.props, "dislike")}
                  //   >
                  //     <i class="material-icons dp48 thumbs-down">thumb_down</i>{" "}
                  //   </div> */}
              {/* </div> */}
              {/* </div> */}
              {/* // )} */}
            </div>
          </div>
        )}
        {this.props.speaks === "exitflow" && this.props.actions && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel  z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one ">
                  <span className="black-text">
                    Workflow enabled, Do you want to exit the flow?
                  </span>
                  <MessageActions actions={this.props.actions} />
                </div>
              </div>
            </div>
          </div>
        )}

        {this.props.speaks == "me" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel   z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero ">
                {this.props.text && (
                  <div className="col s10 right-align msg-content-wrapper message-content-wrapper-user border-b-r-one ">
                    <span
                      className={
                        this.props.fontsize === "medium"
                          ? "black-text-me-medium"
                          : this.props.fontsize === "large"
                          ? "black-text-me-large"
                          : this.props.fontsize === "small"
                          ? "black-text-me-small"
                          : "black-text-me"
                      }
                    >
                      {this.props.text}
                    </span>
                  </div>
                )}

                {/* <a className="btn-floating btn-large waves-effect waves-light deep-purple accent-4">
                      {props.speaks}</a> */}
                {/* <div className="col s2 padding-zero avatar-style">
                  
                  <img
                    className="bot-avatar-image"
                    src={get_Picture(this.props.logInData.username)}
                  />
                </div> */}
              </div>
              {/* TimeStamp */}
              {!this.props.is_notification == true &&
                this.props.speaks == "me" && (
                  <div className="row margin-b-zero  reaction-button-wrapper ">
                    <div className="col padding-zero time-width-r">
                      {/* time-width-r */}
                      <AdyaTimeStamp />
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}

        {/* speaks=guided menu */}
        {this.props.speaks == "bot1" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.type == "menu" && (
                  <div
                    className="col s12"
                    style={{
                      fontSize:
                        this.props.fontSize === "medium" ? "15px" : "10px",
                    }}
                  >
                    {/* className="col s12 guided-menu-wrapper" */}
                    {/* Guided Menu Component Card */}
                    {/* <GuidedMenuCard
                      onCallback={this.props.onCallback}
                      onTriggerWorkflow={this.props.onTriggerWorkflow}
                      onCallFaqMenu={this.props.onCallFaqMenu}
                      // isFloatin={false}
                      buttons={this.props.menuData.BODY.details.data.buttons}
                      font={this.props.font}
                    ></GuidedMenuCard> */}
                    <GuidedMenuCard
                      onCallback={this.props.onCallback}
                      onTriggerWorkflow={this.props.onTriggerWorkflow}
                      onCallFaqMenu={this.props.onCallFaqMenu}
                      buttons={
                        this.props.menuData?.BODY?.details?.data?.buttons || []
                      }
                      font={this.props.fontSize}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {this.props.speaks == "bot1" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.type == "faqmenu" && (
                  <div className="col s12">
                    {/* className="col s12 guided-menu-wrapper" */}
                    {/* FaqMenu Component Card */}
                    <FaqMenuCard
                      onFaqMenuData={this.props.faqMenuData}
                      font={this.props.font}
                    ></FaqMenuCard>

                    {/* <FaqMenuCardTest
                      onFaqMenuData={this.props.faqMenuData}
                    ></FaqMenuCardTest> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "welcome" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {/* {this.props.type == "faqmenu" && ( */}
                <div className="col s12">
                  <WelcomeMessage></WelcomeMessage>
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "UserPreferenceModal" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {/* {this.props.type == "faqmenu" && ( */}
                <div className="col s12">
                  <UserSelectorModal />
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        )}

        {/* speaks=herocard */}
        {this.props.speaks == "bot1" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero  ">
                {this.props.type == "herocard" && (
                  <div
                    className="col s12"
                    style={{ marginBottom: "20px", marginTop: "-10px" }}
                  >
                    <HeroCardMenu
                      herocardData={this.props.herocardData.BODY.details.data}
                    ></HeroCardMenu>
                    <div>
                      <AdyaLikeDislikeButton
                        message={this.props}
                        style={{ marginTop: "-20px !important" }}
                      />
                    </div>

                    {/* TEST */}
                    {/* <HermesRating
                      query={this.props.previousQuery}
                      message={this.props}
                    ></HermesRating> */}
                    {/* <div
                      class="icon-preview col s2 m3"
                      onClick={() => this.sendFeedback(this.props, "like")}
                    >
                      <i class="material-icons dp48 thumbs-up">thumb_up</i>{" "}
                    </div>
                    <div
                      class="icon-preview col s2 m3"
                      onClick={() => this.sendFeedback(this.props, "dislike")}
                    >
                      <i class="material-icons dp48 thumbs-down">thumb_down</i>{" "}
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "agrlink" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero  ">
                {this.props.type == "agrlink" && (
                  <div className="col s12">
                    <AgrLinkData
                      herocardData={this.props.herocardData}
                    ></AgrLinkData>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* speaks=ads */}
        {this.props.speaks == "ads" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero  ">
                {/* {this.props.type == "advertisement" && ( */}
                <div className="col s12 ads-outer" style={{ width: "110%" }}>
                  {/* Advertisement Component ads-outer */}
                  <AdsCarousal
                    adsData={this.props.adsData}
                    adverts={this.props.adsData.data.adImageData}
                  ></AdsCarousal>
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        )}

        {/* speaks=quickmenu */}
        {this.props.speaks == "quickmenu" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero  ">
                {this.props.type == "quickmenu" && (
                  <div
                    className="col s12"
                    style={{
                      fontSize:
                        this.props.fontSize === "medium" ? "15px" : "10px",
                    }}
                  >
                    {/* Quick Menu Component ads-outer */}

                    <QuickMenuCard
                      onCallback={this.props.onCallback}
                      onCallUpcomingMessage={this.props.onCallUpcomingMessage}
                      onTriggerWorkflow={this.props.onTriggerWorkflow}
                      onCallFaqMenu={this.props.onCallFaqMenu}
                      buttons={
                        this.props.quickmenuData.BODY.details.data.buttons
                      }
                      fontSize={this.props.fontSize}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* speaks=workflow */}
        {this.props.speaks == "otp" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s12">
                  {/* Date of Birth Component needs to be created for DOB filling */}
                  <OtpValidation
                    workflowDataHandler={this.props.workflowDataHandler}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "mobile" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s12">
                  {/* Date of Birth Component needs to be created for DOB filling */}
                  <MobileNumber
                    workflowDataHandler={this.props.workflowDataHandler}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "viewAccount" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s12">
                  {/* Date of Birth Component needs to be created for DOB filling */}
                  {/* <MobileNumber
                    workflowDataHandler={this.props.workflowDataHandler}
                  /> */}
                  <ViewAccountDetails viewaccountdetails={this.props.text} />
                </div>
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "cif" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel  z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s10  msg-content-wrapper message-content-wrapper-bot border-b-l-one ">
                  <span className="black-text">Do you want to block all transactions? Please confirm.
                    <br></br> Note: For unblocking, you will need to contact your home branch.</span>
                  <MessageActions actions={this.props.actions} />
                </div>
              </div>
            </div>
          </div>
        )}

        {this.props.speaks == "termDeposit" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s12">
                  {/* Date of Birth Component needs to be created for DOB filling */}
                  {/* <MobileNumber
                    workflowDataHandler={this.props.workflowDataHandler}
                  /> */}
                  <TermDepositEnquiry termDeposit={this.props.text} />{" "}
                </div>
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "scp_form" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                <div className="col s12">
                  {/* Date of Birth Component needs to be created for DOB filling */}
                  {/* <MobileNumber
                    workflowDataHandler={this.props.workflowDataHandler}
                  /> */}
                  <StopChequePaymentForm onSendWorkFlowSCPData={this.onSendWorkFlowSCPData} />
                </div>
              </div>
            </div>
          </div>
        )}

        {this.props.speaks == "workflow" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {/* workflow outputs => text || OTP component || DOB Component */}

                {/* Text */}
                {this.props.workflowData.BODY.type == "text" && (
                  // Message Box css needs to be changed later
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper   border-b-l-one  notification_item"
                        : "col s12  msg-content-wrapper message-content-wrapper-bot-workflow border-b-l-one"
                    }
                    // style={{
                    //   background: this.props.agent && "rgb(201 202 210)",
                    // }}
                  >
                    {this.props.reply_to != undefined &&
                      this.props.reply_to != "" && (
                        <p className="pointToSomeone">@{this.props.reply_to}</p>
                      )}
                    <span className="black-text">
                      {" "}
                      {this.props.text.length > 250 &&
                      !this.state.isShowMoreClicked
                        ? Parser(this.props.text.slice(0, 250))
                        : Parser(this.props.text)}
                    </span>
                    {/* {!this.state.isShowMoreClicked &&
                      this.props.text.length > 250 && (
                        <span
                          className="black-text cursor_pointer"
                          style={{ textDecoration: "underline" }}
                          onClick={() => this.toggleisShowMoreClicked(true)}
                        >
                          {" "}
                          more
                        </span>
                      )}
                    {this.state.isShowMoreClicked && (
                      <span className="black-text">
                        {" "}
                        {Parser(this.props.text)}
                      </span>
                    )}
                    {this.state.isShowMoreClicked && (
                      <span
                        className="black-text cursor_pointer"
                        style={{ textDecoration: "underline" }}
                        onClick={() => this.toggleisShowMoreClicked(false)}
                      >
                        {" "}
                        less
                      </span>
                    )} */}
                  </div>
                )}
                {/* DOB */}
                {this.props.workflowData.BODY.type == "dob" && (
                  <div className="col s12">
                    {/* Date of Birth Component needs to be created for DOB filling */}
                    <DateofBirthCard
                      onSendWorkflowDateOfBirth={
                        this.props.onSendWorkflowDateOfBirth
                      }
                      language={this.props.language}
                    />

                    {/* TEST */}
                    {/* <DateOfBirthSelect
                      onSendWorkflowDateOfBirth={
                        this.props.onSendWorkflowDateOfBirth
                      }
                    /> */}
                  </div>
                )}
                {/* POC Cif and DOB */}

                {/* {this.props.workflowData.BODY.type == "cifdob" && (
                  <div className="col s12">
                    <CifDateofBirthForm
                      onSendWorkflowCifDateOfBirth={
                        this.props.onSendWorkflowCifDateOfBirth
                      }
                    />
                  </div>
                )} */}

                {/* Account */}
                {/* {this.props.workflowData.BODY.type == "account" && (
                  // Single Account Component
                  <div className="col s12">
                    <SingleAccount
                      singleAccountData={this.props.workflowData.BODY.data}
                    />
                  </div>
                )} */}

                {/* Account or Accounts Component based on type */}
                {/* {this.props.workflowData.BODY.type == "accounts" && (
                  <div className="col s12">
                    <MultipleAccountsModal
                      multipleAccountData={this.props.workflowData.BODY.data}
                    />
                  </div>
                )} */}
                {/* Account List */}
                {this.props.workflowData.BODY.type == "account_list" && (
                  <div className="col s12">
                    {/* <CifDateofBirthForm
                      onSendWorkflowCifDateOfBirth={
                        this.props.onSendWorkflowCifDateOfBirth
                      }
                    /> */}
                    <AccountList
                      accountListData={this.props.workflowData.BODY.data}
                      onSendWorkflowAccountList={
                        this.props.onSendWorkflowSelectedAccount
                      }
                      accountListNoData={this.props.accountListNoData}
                      language={this.props.language}
                    />
                  </div>
                )}

                {/* Account Balance */}
                {this.props.workflowData.BODY.type == "account_balance" && (
                  // Single Account Component
                  <div className="col s12">
                    <SingleAccount
                      singleAccountData={this.props.workflowData.BODY.data}
                    />
                    <div>
                      {/* <AdyaTimeStamp /> */}
                      <AdyaLikeDislikeButton
                        message={this.props}
                        style={{ marginTop: "-10px" }}
                      />
                    </div>
                  </div>
                )}

                {/* Mini-Statement */}
                {this.props.workflowData.BODY.type == "mini_statement" && (
                  // Single Account Component
                  <div className="col s12">
                    {/* herocardData={this.props.herocardData.BODY.details.data} */}

                    {/* <TransactionModal miniStatementData={this.props.workflowData.BODY.data} /> */}
                    {/* <TransactionList miniStatementData={this.props.workflowData.BODY.data}/> */}
                    {/* <TransactionTable miniStatementData={this.props.workflowData.BODY.data}/> */}

                    {/* Inside a Pop Up Modal */}
                    {/* <TransactionTable
                      miniStatementData={this.props.workflowData.BODY.data}
                    /> */}

                    {/* <MiniStatementCard
                      miniStatementData={this.props.workflowData.BODY.data}
                    /> */}

                    {/* <MiniStatementList
                      miniStatementData={this.props.workflowData.BODY.data}
                    /> */}

                    {/* <MiniStatementListTest
                      miniStatementData={this.props.workflowData.BODY.data}
                    /> */}

                    {/* UAT */}
                    <MiniStatementUAT
                      miniStatementData={this.props.workflowData.BODY.data}
                    />

                    {/* <MiniStatementUATDemo
                      miniStatementData={this.props.workflowData.BODY.data}
                    /> */}

                    <AdyaLikeDislikeButton message={this.props} />
                  </div>
                )}

                {/* Cheque Book Form */}
                {this.props.workflowData.BODY.type == "cheque_book_form" && (
                  <div className="col s12">
                    {/* Cheque Book Form Component */}
                    {this.props.workflowData.BODY.data[0].metaData.status
                      .desc == "Success" && (
                      <ChequeBookFormRequest
                        cbrFormData={this.props.workflowData.BODY.data}
                        onSendChequeBookFormData={
                          this.props.onSendChequeBookFormData
                        }
                      />
                    )}
                    {this.props.workflowData.BODY.data[0].metaData.status
                      .desc == "Bad Request" && (
                      <ChequeBookFormRequestErrRes
                        cbrFormData={this.props.workflowData.BODY.data}
                        // onSendChequeBookFormData={
                        //   this.props.onSendChequeBookFormData
                        // }
                      />
                    )}
                  </div>
                )}

                {/* Cheque Book Request */}
                {this.props.workflowData.BODY.type == "cheque_book_request" && (
                  <div className="col s12">
                    {/* Cheque Book Request Component */}
                    <ChequeBookRequest
                      chequeBookRequestData={this.props.workflowData.BODY.data}
                    />

                    <AdyaLikeDislikeButton message={this.props} />
                  </div>
                )}

                {/* Adya Actions this.props.adyaActions */}
                {/* {this.props.adyaActions && (
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper border-b-l-one  notification_item"
                        : "col s10  msg-content-wrapper message-content-wrapper-bot-workflow border-b-l-one"
                    }
                  >
                    <span className="black-text">
                      "Thank You for Using Adya 😃! Do You Want To Check Balance of
                      Another Account?" <br />
                    </span>
                    <MessageActions
                      actions={this.props.adyaActions}
                    ></MessageActions>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        )}

        {this.props.speaks == "agrDp" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.workflowData.data.MESSAGE.RESULT[0].BODY.prompt ==
                  "date_picker" && (
                  <div className="col s12">
                    <DatePicker
                      onSendWorkflowDatePicker={
                        this.props.onSendWorkflowDatePicker
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "agrDr" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.workflowData?.data?.MESSAGE?.RESULT[0]?.BODY
                  ?.prompt == "date_range" && (
                  <div className="col s12">
                    <DateRange
                      handleSendWorkflowDateRange={
                        this.props.handleSendWorkflowDateRange
                      }
                      language="en"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "agr" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.workflowData.from == "agr" && (
                  // Message Box css needs to be changed later
                  <div
                    className={
                      this.props.is_notification
                        ? "col s10  msg-content-wrapper   border-b-l-one  notification_item"
                        : "col s12  msg-content-wrapper message-content-wrapper-bot-workflow border-b-l-one"
                    }
                  >
                    {/* {this.props.reply_to != undefined &&
                      this.props.reply_to != "" && (
                        <p className="pointToSomeone">@{this.props.reply_to}</p>
                      )}
                    <span className="black-text">
                      {" "}
                      {this.props.text.length > 250 &&
                      !this.state.isShowMoreClicked
                        ? Parser(this.props.text.slice(0, 250))
                        : Parser(this.props.text)}
                    </span> */}
                  </div>
                )}
                {/* Transaction list */}
                {this.props.workflowData.from == "agr" && (
                  <div className="col s12">
                    <AgrAccountList
                      accountListData={this.props.workflowData.data}
                      onSendAgrWorkflowAccountList={
                        this.props.onSendWorkflowSelectedAccount
                      }
                      // accountListNoData={this.props.accountListNoData}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.speaks == "ste" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.workflowData.BODY.type == "date_range" && (
                  <div className="col s12">
                    <DateRangeste
                      generatesteDrflowData={this.props.generatesteDrflowData}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* adya nlp qa */}
        {this.props.speaks == "adya_nlp" && (
          <div className="col s12 m8 offset-m2 offset-13 msg-outer">
            <div className="card-panel z-depth-1 custom-card-panel ">
              <div className="row valign-wrapper margin-b-zero">
                {this.props.type == "adya_nlp" && (
                  <div className="col s12" style={{ marginBottom: "20px" }}>
                    {/* <NlpQaCard adynlpdata = {this.props.adynlpData.BODY.DOCUMENTS}/> */}
                    {/* <NlpQaCard
                      adyanlpdata={this.props.adyanlpData.BODY}
                      adyaNlpQuery={this.props.adyaNlpQuery}
                    /> */}
                    {/* <NlpCardTest /> */}
                    <NlpCardHerocard
                      adyanlpdata={this.props.adyanlpData.BODY}
                    />
                    <div>
                      {/* <AdyaTimeStamp /> */}
                      <AdyaLikeDislikeButton
                        message={this.props}
                        className="nlpcard"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isTyping: state.isTyping.isTyping,
    isOpened: state.modalStatus.isOpened,
    modalUrl: state.modalStatus.modal_url,
    logInData: state.logInStatus,
    talk_to_what: state.talk_to_what.name,
    botType: state.botType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    close_modal: () => {
      dispatch(close_modal);
    },
    open_modal: (payload) => {
      dispatch({ type: "MODAL_TYPE_ACTION", payload: payload });
      dispatch(open_modal);
    },
    open_modal_for_data: (readMoreClicked, url) => {
      dispatch({ type: "MODAL_TYPE_ACTION", payload: "dataList" });
      dispatch({ type: "MODAL_URL_ACTION", payload: url });
      dispatch({ type: "MODAL_STATUS_ACTION", payload: readMoreClicked });
    },
    open_modal_for_images: (images) => {
      dispatch({ type: "MODAL_IMAGE_DATA_ACTION", payload: images });
      dispatch({ type: "MODAL_TYPE_ACTION", payload: "image" });
      dispatch({ type: "MODAL_STATUS_ACTION", payload: true });
    },
    open_modal_for_pdf: (pdf) => {
      dispatch({ type: "MODAL_IMAGE_DATA_ACTION", payload: pdf });
      dispatch({ type: "MODAL_TYPE_ACTION", payload: "pdf" });
      dispatch({ type: "MODAL_STATUS_ACTION", payload: true });
    },
    update_botTyping_to_true: () => {
      dispatch(update_botTyping_to_true);
    },
    update_botTyping_to_false: () => {
      dispatch(update_botTyping_to_false);
    },
    set_table_list_data: (tableData) => {
      dispatch({ type: "TABLE_DATA_ACTION", payload: tableData });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Message);
